import { useState, useCallback } from "react";
import {
  ReactFlow,
  applyNodeChanges,
  applyEdgeChanges,
  addEdge,
  type Node,
  type Edge,
  type NodeChange,
  type EdgeChange,
  type Connection,
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { stdObject } from "../../../data/types/stdObject";
import { colors } from "../../../data/colors";
import { sendData } from "../../../services/sendData";
import { useMainContext } from "../../../context/MainContext";

export default function Diagram() {
  const { logoutAction } = useMainContext();
  const usersList: stdObject = useSelector(
    (state: RootState) => state.data.usersList,
  );
  const userAccess: stdObject = useSelector(
    (state: RootState) => state.data.userAccess,
  );
  const areasList: any = useSelector((state: RootState) => state.data.are);
  const areaLinks: any = useSelector(
    (state: RootState) => state.data.areaLinks,
  );
  const areaUsers: any = useSelector(
    (state: RootState) => state.data.areaUsers,
  );

  const [nodes, setNodes] = useState<Node[]>(
    areasList.map((e: stdObject) => {
      return {
        id: `n${e.CODARE}`,
        position: { x: e.XARE, y: e.YARE },
        data: {
          label: (
            <div>
              <div style={{ fontWeight: "bold", fontSize: 14 }}>{e.NOMARE}</div>
              {areaUsers
                .filter((v: stdObject) => v.CODARU === e.CODARE)
                .map((v: stdObject, index: number) => (
                  <div key={index} style={{ fontSize: 12 }}>
                    {usersList[v.CODARU]?.NOMUSU}
                  </div>
                ))}
            </div>
          ),
        },
        style: {
          backgroundColor: e.COLARE,
          color: colors.white,
          fontSize: "12px",
          padding: "5px",
          borderRadius: "8px",
        },
      };
    }),
  );
  const [edges, setEdges] = useState<Edge[]>(
    areaLinks.map((e: stdObject) => {
      return {
        id: `n${e.CODAR0}-n${e.COD2AR0}`,
        source: `n${e.CODAR0}`,
        target: `n${e.COD2AR0}`,
      };
    }),
  );

  const getName = (code: string) =>
    areasList.find((e: stdObject) => e.CODARE === Number(code))?.NOMARE;

  const sendInfo = async (payload: stdObject) => {
    console.log("payload", payload);
    const responseSendInfo: stdObject = await sendData({
      endPoint: "saveAreaInfo",
      payload,
      logoutAction,
    });
    console.log("responseSendInfo", responseSendInfo);
  };

  const onNodesChange = useCallback(
    (changes: NodeChange[]) =>
      setNodes((nodesSnapshot) => applyNodeChanges(changes, nodesSnapshot)),
    [],
  );

  const onNodeDragStop = async (_: any, node: Node) => {
    sendInfo({
      type: "moved",
      code: node.id.replace("n", ""),
      name: getName(node.id.replace("n", "")),
      ...node.position,
    });
  };

  const onEdgesChange = useCallback(
    (changes: EdgeChange[]) =>
      setEdges((edgesSnapshot) => applyEdgeChanges(changes, edgesSnapshot)),
    [],
  );

  const onConnect = useCallback((params: Connection) => {
    setEdges((edgesSnapshot) => addEdge(params, edgesSnapshot));
    sendInfo({
      type: "linked",
      name: getName(params.source.replace("n", "")),
      source: params.source.replace("n", ""),
      target: params.target.replace("n", ""),
    });
  }, []);

  const onEdgesDelete = (deletedEdges: Edge[]) => {
    setEdges((edges) =>
      edges.filter((e) => !deletedEdges.some((d) => d.id === e.id)),
    );
    sendInfo({
      type: "unlinked",
      links: deletedEdges.map((e: stdObject) => {
        return {
          name: getName(e.source.replace("n", "")),
          source: e.source.replace("n", ""),
          target: e.target.replace("n", ""),
        };
      }),
    });
  };

  return (
    <div className="listBox">
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onNodeDragStop={onNodeDragStop}
        onEdgesChange={onEdgesChange}
        onEdgesDelete={onEdgesDelete}
        deleteKeyCode="Delete" // o "Backspace"
        nodesDraggable={userAccess.D.D4 === 2}
        nodesConnectable={userAccess.D.D4 === 2}
        elementsSelectable={userAccess.D.D4 === 2}
        onConnect={onConnect}
        fitView
      />
    </div>
  );
}
